var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    { staticClass: "asc__insertPage" },
    [
      _c("b-col", { attrs: { cols: "12" } }, [
        _c(
          "header",
          [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  { attrs: { cols: "12", md: "6" } },
                  [_c("Breadcrumb")],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  { staticClass: "text-right", attrs: { cols: "12", md: "6" } },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: { name: "PotentialCustomer" } } },
                      [_c("CancelButton")],
                      1
                    ),
                    _vm._v(" "),
                    _c("AddButton", {
                      attrs: { title: _vm.$t("header.confirm") },
                      nativeOn: {
                        click: function($event) {
                          return _vm.save()
                        }
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "b-col",
        { staticClass: "asc__insertPage-content-head", attrs: { cols: "12" } },
        [_c("section", [_c("b-row")], 1)]
      ),
      _vm._v(" "),
      _c(
        "b-col",
        { attrs: { cols: "12" } },
        [
          _c(
            "b-tabs",
            [
              _c(
                "b-tab",
                { attrs: { title: _vm.$t("insert.detail"), active: "" } },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "CommercialTitle",
                            error: _vm.$v.form.CommercialTitle
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: {
                              type: "text",
                              disabled: _vm.insertReadonly.CommercialTitle
                            },
                            model: {
                              value: _vm.form.CommercialTitle,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "CommercialTitle", $$v)
                              },
                              expression: "form.CommercialTitle"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "TaxOffice",
                            error: _vm.$v.form.TaxOffice
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: {
                              type: "text",
                              disabled: _vm.insertReadonly.TaxOffice
                            },
                            model: {
                              value: _vm.form.TaxOffice,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "TaxOffice", $$v)
                              },
                              expression: "form.TaxOffice"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "TaxNumber",
                            error: _vm.$v.form.TaxNumber
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: {
                              type: "text",
                              disabled: _vm.insertReadonly.TaxNumber
                            },
                            model: {
                              value: _vm.form.TaxNumber,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "TaxNumber", $$v)
                              },
                              expression: "form.TaxNumber"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "Description1",
                            error: _vm.$v.form.Description1
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: {
                              type: "text",
                              disabled: _vm.insertReadonly.Description1
                            },
                            model: {
                              value: _vm.form.Description1,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "Description1", $$v)
                              },
                              expression: "form.Description1"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "LicenseNumber",
                            error: _vm.$v.form.LicenseNumber
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: {
                              type: "text",
                              disabled: _vm.insertReadonly.LicenseNumber
                            },
                            model: {
                              value: _vm.form.LicenseNumber,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "LicenseNumber", $$v)
                              },
                              expression: "form.LicenseNumber"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "TypeId",
                            error: _vm.$v.form.TypeId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              "lookup-key": "CUSTOMER_TYPE",
                              disabled: _vm.insertReadonly.TypeId
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedType("TypeId", $event)
                              }
                            },
                            model: {
                              value: _vm.Type,
                              callback: function($$v) {
                                _vm.Type = $$v
                              },
                              expression: "Type"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "DefaultPaymentTypeId",
                            error: _vm.$v.form.DefaultPaymentTypeId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              url: "VisionNextCommonApi/api/PaymentType/Search",
                              disabled: _vm.insertReadonly.DefaultPaymentTypeId
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedSearchType(
                                  "DefaultPaymentTypeId",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.DefaultPaymentType,
                              callback: function($$v) {
                                _vm.DefaultPaymentType = $$v
                              },
                              expression: "DefaultPaymentType"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "PriceListCategoryId",
                            error: _vm.$v.form.PriceListCategoryId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              "lookup-key": "PRICE_LIST_CATEGORY_TYPE",
                              disabled: _vm.insertReadonly.PriceListCategoryId
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedType(
                                  "PriceListCategoryId",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.PriceListCategory,
                              callback: function($$v) {
                                _vm.PriceListCategory = $$v
                              },
                              expression: "PriceListCategory"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "Barcode",
                            error: _vm.$v.form.Barcode
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: {
                              type: "text",
                              disabled: _vm.insertReadonly.Barcode
                            },
                            model: {
                              value: _vm.form.Barcode,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "Barcode", $$v)
                              },
                              expression: "form.Barcode"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "Genexp1",
                            error: _vm.$v.form.Genexp1
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: {
                              type: "text",
                              disabled: _vm.insertReadonly.Genexp1
                            },
                            model: {
                              value: _vm.form.Genexp1,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "Genexp1", $$v)
                              },
                              expression: "form.Genexp1"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "Statement",
                            error: _vm.$v.form.Statement
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: {
                              type: "text",
                              disabled: _vm.insertReadonly.Statement
                            },
                            model: {
                              value: _vm.form.Statement,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "Statement", $$v)
                              },
                              expression: "form.Statement"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "InvoiceCombineRuleId",
                            error: _vm.$v.form.InvoiceCombineRuleId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              "lookup-key": "INVOICE_COMBINE_RULE",
                              disabled: _vm.insertReadonly.InvoiceCombineRuleId
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedType(
                                  "InvoiceCombineRuleId",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.InvoiceCombineRule,
                              callback: function($$v) {
                                _vm.InvoiceCombineRule = $$v
                              },
                              expression: "InvoiceCombineRule"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "SalesDocumentTypeId",
                            error: _vm.$v.form.SalesDocumentTypeId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              "lookup-key": "SALES_DOCUMENT_TYPE",
                              disabled: _vm.insertReadonly.SalesDocumentTypeId
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedType(
                                  "SalesDocumentTypeId",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.SalesDocumentType,
                              callback: function($$v) {
                                _vm.SalesDocumentType = $$v
                              },
                              expression: "SalesDocumentType"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "IsWarehouseSale",
                            error: _vm.$v.form.IsWarehouseSale
                          }
                        },
                        [
                          _c("NextCheckBox", {
                            attrs: {
                              type: "number",
                              toggle: "",
                              disabled: _vm.insertReadonly.IsWarehouseSale
                            },
                            model: {
                              value: _vm.form.IsWarehouseSale,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "IsWarehouseSale", $$v)
                              },
                              expression: "form.IsWarehouseSale"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "IsOrderChangeUnitary",
                            error: _vm.$v.form.IsOrderChangeUnitary
                          }
                        },
                        [
                          _c("NextCheckBox", {
                            attrs: {
                              type: "number",
                              toggle: "",
                              disabled: _vm.insertReadonly.IsOrderChangeUnitary
                            },
                            model: {
                              value: _vm.form.IsOrderChangeUnitary,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "IsOrderChangeUnitary", $$v)
                              },
                              expression: "form.IsOrderChangeUnitary"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("hr"),
                  _vm._v(" "),
                  _c("NextAddress", {
                    attrs: { init: _vm.init },
                    model: {
                      value: _vm.address,
                      callback: function($$v) {
                        _vm.address = $$v
                      },
                      expression: "address"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t("insert.customer.Model_PhoneNumber1")
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: { type: "text" },
                            model: {
                              value: _vm.CustomerLocations.PhoneNumber1,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.CustomerLocations,
                                  "PhoneNumber1",
                                  $$v
                                )
                              },
                              expression: "CustomerLocations.PhoneNumber1"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t("insert.customer.Model_FaxNumber")
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: { type: "text" },
                            model: {
                              value: _vm.CustomerLocations.FaxNumber,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.CustomerLocations,
                                  "FaxNumber",
                                  $$v
                                )
                              },
                              expression: "CustomerLocations.FaxNumber"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-49cfa280", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49cfa280","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PotentialCustomer/update.vue
// module id = null
// module chunks = 